import { useParams } from 'react-router-dom';

// Global detected subdomain (set from App.js)
let _detectedSubdomain = null;
export function setDetectedSubdomain(sub) { _detectedSubdomain = sub; }

export default function useStoreSubdomain() {
  const params = useParams();
  return params.subdomain || _detectedSubdomain;
}

// Helper to generate correct store paths (clean URLs on subdomain, /store/:subdomain on main domain)
export function useStorePath() {
  const params = useParams();
  const subdomain = params.subdomain || _detectedSubdomain;
  const onSubdomain = !!_detectedSubdomain;
  return (path = '') => onSubdomain ? (path || '/') : `/store/${subdomain}${path}`;
}
